/**
 * 報修明細 `accessories`：BE 為單一字串，前端以「換行」分隔多個配件。
 * UI 以共用 `TagInput` 編輯；wire 格式不變（標籤以 `\n` 串接）。
 * 輸入拆分見 `commonComponents/form/tagInputUtils.js`。
 */

const ACCESSORY_SEPARATOR = '\n';

/** @param {string | null | undefined} value BE／表單字串 */
export function parseAccessories(value) {
  if (typeof value !== 'string') return [];
  return value
    .split(/\r?\n/)
    .map((part) => part.trim())
    .filter(Boolean);
}

/** @param {string[]} tags */
export function joinAccessories(tags) {
  return (tags ?? [])
    .map((tag) => String(tag).trim())
    .filter(Boolean)
    .join(ACCESSORY_SEPARATOR);
}
